export default {
  cargoMateEmail: 'cargomate.support@hlag.com',
  cargoMateMailto: 'mailto:cargomate.support@hlag.com',
  feedbackEmail: 'cargomate.support@hlag.com',
  feedbackMailTo: `mailto:cargomate.support@hlag.com?subject=CargoMate%20dashboard%20v${WEB_DASHBOARD_VERSION}%20feedback`,
  helpCentreURL: 'https://intelligentcargosystems.zendesk.com',
}
